import { memo } from 'react';

import { InfoIcon } from '@air/design-icons';
import { Tooltip } from '@air/primitive-tooltip';

type PermissionToggleInfoProps = {
  text: string;
  className?: string;
};

export const PermissionToggleInfo = memo(({ text, className }: PermissionToggleInfoProps) => (
  <Tooltip label={text} className={className}>
    <InfoIcon size="sm" className="ads:text-icon-default text-gray-10" />
  </Tooltip>
));

PermissionToggleInfo.displayName = 'PermissionToggleInfo';
